import React from 'react';

const Back = (props) => {
  const {
    previousRoute,
    isInReview,
    actions,
    history
  } = props;

  const onClick = (e) => {
    e.preventDefault();

    if (isInReview) {
      return actions.getApplication()
        .then(() => {
          history.push(previousRoute);
        })
        .catch(console.log);
    }

    history.push(previousRoute);
  };

  return <a className='back-navigation-container' onClick={onClick}>
    <div className='back-navigation' />
    <div className='back-navigation-text'>{ isInReview && 'Cancel' }</div>
  </a>;
};

export default Back;



